import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import "./styles/main.scss";
import { Toaster } from "sonner";

/**
 * Страницы грузятся по требованию: на списке шаблонов не нужен код
 * редактора, а видео-галерея нужна вообще редко.
 *
 * Фолбэк намеренно без antd — иначе antd прибьётся к главному чанку
 * и разбиение потеряет смысл.
 */
const Templates = lazy(() => import("./pages/Templates"));
const Editor = lazy(() => import("./pages/Editor"));
const LichiVideoPage = lazy(() => import("./pages/LichiVideoPage"));

const PageFallback = () => (
	<div
		style={{
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			minHeight: "60vh",
			opacity: 0.5,
		}}
	>
		Загрузка...
	</div>
);

function App() {
	return (
		<div className="app">
			<div className="main">
				<Toaster />
				<Suspense fallback={<PageFallback />}>
					<Routes>
						<Route path="/" element={<Templates />} />
						<Route path="/:pageId" element={<Editor />} />
						<Route path="/video_gallery" element={<LichiVideoPage />} />
					</Routes>
				</Suspense>
			</div>
		</div>
	);
}

export default App;
